import React, {MouseEvent} from "react"

import styles from '../css/Text.module.css';
import {toI18N} from "../utils/I18n";

export interface Props {
    onNext?: (event: MouseEvent) => void,
}

export default (props: Props) => {
    const {onNext} = props;
    return (<span onClick={onNext} className={styles.skip}> {toI18N('skip')} </span>)
}
